const isIncludedInArray = (array,payload)=>{
    return array.includes(payload)
}

export default isIncludedInArray